module.exports = new __parcel__URL__("icon-home.b876a652.svg").toString();